// Mirrors the backend Domain\CompanyChange\Models\CompanyChangeRequest fillable
// (verbonden repo). Keep these keys in sync with that model.
export interface ICompanyChange {
  id: number;
  name: string;
  customer_number: string;
  phone: string;
  email: string;
  old_company_name: string;
  old_address: string;
  old_postal_code: string;
  old_city: string;
  new_company_name: string;
  new_kvk: string;
  new_address: string;
  new_house_number: string;
  new_postal_code: string;
  new_city: string;
  new_company_email: string;
  change_date: string;
  is_company_takeover: boolean;
  terms_accepted: boolean;
  created_at: string;
}

export const defaultCompanyChange: ICompanyChange = {
  id: 0,
  name: '',
  customer_number: '',
  phone: '',
  email: '',
  old_company_name: '',
  old_address: '',
  old_postal_code: '',
  old_city: '',
  new_company_name: '',
  new_kvk: '',
  new_address: '',
  new_house_number: '',
  new_postal_code: '',
  new_city: '',
  new_company_email: '',
  change_date: '',
  is_company_takeover: false,
  terms_accepted: false,
  created_at: '',
};
